// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rewards-section {
  display: flex;
  column-gap: 8px;
  justify-content: center;
}
.rewards-section img {
  width: 25px;
}
.rewards-section span {
  font-weight: 600;
  font-size: 35px;
  line-height: 24px;
}
@media screen and (max-width: 568px) {
  .rewards-section span {
    font-size: 30px;
  }
}

.amount-cash-flow-style p {
  font-size: 12px;
  line-height: 10px;
}
@media screen and (max-width: 568px) {
  .amount-cash-flow-style p {
    font-size: 10px;
  }
}

.amount-cash-input-style {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  column-gap: 10px;
  flex-basis: min-content;
}
.amount-cash-input-style .rp-amount-style {
  display: flex;
  width: 90%;
  position: relative;
  justify-content: center;
  justify-content: center;
}
.amount-cash-input-style p {
  font-weight: 500;
  font-size: 11px;
  line-height: 21px;
}
@media screen and (max-width: 568px) {
  .amount-cash-input-style p {
    font-size: 10px;
    line-height: 20px;
  }
}
.amount-cash-input-style span {
  font-weight: 500;
  font-size: 12px;
  width: 21%;
  height: 100%;
  position: absolute;
  left: 0%;
  text-align: end;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.amount-cash-input-style .info-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.amount-cash-input-style .info-icon ion-icon {
  font-weight: 500;
  font-size: 18px;
}
.amount-cash-input-style ion-input {
  width: 55%;
  height: 35px;
  min-height: 35px;
}

.amount-slider-style {
  width: 80%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  row-gap: 6px;
}
.amount-slider-style span {
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
}
@media screen and (max-width: 568px) {
  .amount-slider-style span {
    font-size: 11px;
  }
}
.amount-slider-style .total-amount {
  font-weight: 600;
  font-size: 35px;
  line-height: 24px;
}
@media screen and (max-width: 568px) {
  .amount-slider-style .total-amount {
    font-size: 30px;
  }
}

.bottom-text-section {
  font-weight: 500;
  font-size: 10px;
  line-height: 21px;
  text-align: center;
}
@media screen and (max-width: 568px) {
  .bottom-text-section {
    width: 75%;
  }
}

.multi-rate-container {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin-top: 20px;
}
@media screen and (max-width: 568px) {
  .multi-rate-container {
    row-gap: 10px;
    margin-top: 15px;
  }
}
.multi-rate-container p {
  font-weight: 500;
  font-size: 11px;
  line-height: 11px;
}
@media screen and (max-width: 568px) {
  .multi-rate-container p {
    font-size: 10px;
    line-height: 10px;
  }
}
.multi-rate-container .rate-button-container {
  display: flex;
  justify-content: center;
  column-gap: 20px;
  line-height: 44px;
  background: var(--ion-color-light);
  border: 1px solid var(--ion-color-dark);
  border-radius: 3px;
  margin: auto;
}
.multi-rate-container .rate-button-container div {
  display: flex;
  justify-content: center;
  flex: 1;
}
.multi-rate-container .rate-button-container .bucket-text {
  font-family: var(--font-secondary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: var(--ion-color-dark);
}
@media screen and (max-width: 568px) {
  .multi-rate-container .rate-button-container .bucket-text {
    font-size: 11px;
  }
}
.multi-rate-container .rate-button-container .bucket-rate {
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 900;
  font-size: 30px;
  text-align: center;
  color: var(--ion-color-dark);
}
@media screen and (max-width: 568px) {
  .multi-rate-container .rate-button-container .bucket-rate {
    font-size: 20px;
  }
}
.multi-rate-container .rate-button-container .bucket-button ion-button {
  width: 100%;
}
.multi-rate-container .row-width {
  width: 80%;
}
@media screen and (max-width: 568px) {
  .multi-rate-container .row-width {
    width: 95%;
  }
}
.multi-rate-container .word-between-lines {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}
.multi-rate-container .word-between-lines .line {
  flex: 1;
  height: 1px;
  background-color: var(--ion-color-dark);
}
.multi-rate-container .word-between-lines .word {
  padding: 0 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rewards-components/rewards-current-status/rewards-current-status.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAEQ;EALJ;IAMQ,eAAA;EACV;AACF;;AAII;EACI,eAAA;EACA,iBAAA;AADR;AAGQ;EAJJ;IAKQ,eAAA;EAAV;AACF;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAGI;EACI,aAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;AADR;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAIQ;EALJ;IAMQ,eAAA;IACA,iBAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAHR;AAKQ;EACI,gBAAA;EACA,eAAA;AAHZ;AAOI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;AALR;;AASA;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AANJ;AAQI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AANR;AAQQ;EALJ;IAMQ,eAAA;EALV;AACF;AAQI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AANR;AAQQ;EALJ;IAMQ,eAAA;EALV;AACF;;AASA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AANJ;AAQI;EANJ;IAOQ,UAAA;EALN;AACF;;AAQA;EAEI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AANJ;AAQI;EAPJ;IAQQ,aAAA;IACA,gBAAA;EALN;AACF;AAOI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AALR;AAOQ;EALJ;IAMQ,eAAA;IACA,iBAAA;EAJV;AACF;AAOI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;AALR;AAOQ;EACI,aAAA;EACA,uBAAA;EACA,OAAA;AALZ;AAQQ;EACI,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AANZ;AAQY;EAPJ;IAQQ,eAAA;EALd;AACF;AAQQ;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AANZ;AAQY;EARJ;IASQ,eAAA;EALd;AACF;AASY;EACI,WAAA;AAPhB;AAYI;EACI,UAAA;AAVR;AAYQ;EAHJ;IAIQ,UAAA;EATV;AACF;AAYI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAVR;AAYQ;EACI,OAAA;EACA,WAAA;EACA,uCAAA;AAVZ;AAaQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAXZ","sourcesContent":[".rewards-section {\n    display: flex;\n    column-gap: 8px;\n    justify-content: center;\n\n    img {\n        width: 25px;\n    }\n\n    span {\n        font-weight: 600;\n        font-size: 35px;\n        line-height: 24px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 30px;\n        }\n    }\n}\n\n.amount-cash-flow-style {\n    p {\n        font-size: 12px;\n        line-height: 10px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 10px;\n        }\n    }\n}\n\n.amount-cash-input-style {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: center;\n    column-gap: 10px;\n    flex-basis: min-content;\n\n    .rp-amount-style {\n        display: flex;\n        width: 90%;\n        position: relative;\n        justify-content: center;\n        justify-content: center;\n    }\n\n    p {\n        font-weight: 500;\n        font-size: 11px;\n        line-height: 21px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 10px;\n            line-height: 20px;\n        }\n    }\n\n    span {\n        font-weight: 500;\n        font-size: 12px;\n        width: 21%;\n        height: 100%;\n        position: absolute;\n        left: 0%;\n        text-align: end;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    .info-icon {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n\n        ion-icon {\n            font-weight: 500;\n            font-size: 18px;\n        }\n    }\n\n    ion-input {\n        width: 55%;\n        height: 35px;\n        min-height: 35px;\n    }\n}\n\n.amount-slider-style {\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    row-gap: 6px;\n\n    span {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 24px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 11px;\n        }\n    }\n\n    .total-amount {\n        font-weight: 600;\n        font-size: 35px;\n        line-height: 24px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 30px;\n        }\n    }\n}\n\n.bottom-text-section {\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 21px;\n    text-align: center;\n\n    @media screen and (max-width: 568px) {\n        width: 75%;\n    }\n}\n\n.multi-rate-container {\n\n    display: flex;\n    flex-direction: column;\n    row-gap: 15px;\n    margin-top: 20px;\n\n    @media screen and (max-width: 568px) {\n        row-gap: 10px;\n        margin-top: 15px;\n    }\n\n    p {\n        font-weight: 500;\n        font-size: 11px;\n        line-height: 11px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 10px;\n            line-height: 10px;\n        }\n    }\n\n    .rate-button-container {\n        display: flex;\n        justify-content: center;\n        column-gap: 20px;\n        line-height: 44px;\n        background: var(--ion-color-light);\n        border: 1px solid var(--ion-color-dark);\n        border-radius: 3px;\n        margin: auto;\n\n        div {\n            display: flex;\n            justify-content: center;\n            flex: 1;\n        }\n\n        .bucket-text {\n            font-family: var(--font-secondary);\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            color: var(--ion-color-dark);\n\n            @media screen and (max-width: 568px) {\n                font-size: 11px;\n            }\n        }\n\n        .bucket-rate {\n            font-family: var(--font-primary);\n            font-style: normal;\n            font-weight: 900;\n            font-size: 30px;\n            text-align: center;\n            color: var(--ion-color-dark);\n\n            @media screen and (max-width: 568px) {\n                font-size: 20px;\n            }\n        }\n\n        .bucket-button {\n            ion-button {\n                width: 100%;\n            }\n        }\n    }\n\n    .row-width {\n        width: 80%;\n\n        @media screen and (max-width: 568px) {\n            width: 95%;\n        }\n    }\n\n    .word-between-lines {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 10px auto;\n\n        .line {\n            flex: 1;\n            height: 1px;\n            background-color: var(--ion-color-dark);\n        }\n\n        .word {\n            padding: 0 10px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
